import { render } from "./SelectInsuredType.vue?vue&type=template&id=0da5a37f&ts=true"
import script from "./SelectInsuredType.vue?vue&type=script&lang=ts"
export * from "./SelectInsuredType.vue?vue&type=script&lang=ts"

import exportComponent from "/home/uatcomp/public_html/wizards/travel-insurance-wizard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__